import { twMerge } from "tailwind-merge";
import { useTranslation } from "react-i18next";

interface LoaderProps {
  className?: string;
  size?: "sm" | "md" | "lg";
  "data-testid"?: string;
}

const SIZE_CLASSES = {
  sm: "w-6 h-6",
  md: "w-10 h-10",
  lg: "w-12 h-12",
};

const SIZE_DIMENSIONS = {
  sm: { width: 24, height: 24 },
  md: { width: 40, height: 40 },
  lg: { width: 48, height: 48 },
};

export const Loader = ({
  className = "",
  size = "lg",
  "data-testid": testId,
}: LoaderProps) => {
  const { t } = useTranslation();

  return (
    <div
      className={twMerge("flex items-center justify-center", className)}
      data-testid={testId}
    >
      <img
        src="/loader.svg"
        alt={t("Loader.loading")}
        className={SIZE_CLASSES[size]}
        width={SIZE_DIMENSIONS[size].width}
        height={SIZE_DIMENSIONS[size].height}
      />
    </div>
  );
};
